<div id="additional-info-add" role="main">
  <mat-card id="additional-file-add-container">
    <mat-card-title role="heading" aria-level="2">{{'cbrne-add-file.add-new-file' | translate}}</mat-card-title>
    <div [formGroup]="form">
    <app-photo-upload formControlName="files" id="info-submit" [mediaTypes]="types"></app-photo-upload>
    <button mat-raised-button type="submit" color="primary" [disabled]="!form.valid" (click)="addFile()">{{'general.submit' | translate}}</button>
    </div>
  </mat-card>
</div>
